module.exports = __webpack_public_path__ + "static/media/ba-pg1.b625a0b3.jpg";